import {UntypedFormGroup, ValidationErrors, AbstractControl, ValidatorFn} from '@angular/forms';
import { getRoleFromName } from '../shared';

export class RoleDisciplineValidator {
  public static validate(form: UntypedFormGroup, roles: any[]): ValidationErrors | null {
    if (!form)
      return;

    let userType = form.controls["userType"].value;
    let primaryDiscipline = form.controls["primaryDiscipline"].value;
    let roleName = form.controls["role"].value;

    if (!userType)// in case the value is null or undefined
      userType = "";
    if (!roleName)// in case the value is null or undefined
      roleName = "";
    if (!primaryDiscipline)// in case the value is null or undefined
      primaryDiscipline = "";

    if (!primaryDiscipline && !roleName && !userType)
      return;

    let discipline = "";
    if (primaryDiscipline)
      discipline = primaryDiscipline.trim();

    let role = roleName.trim();
    let r = getRoleFromName(roles, role);
    if (r) {
      if (!r.isCustomData && r.disciplineRequired && !discipline) {
        return { disciplineRequired: true };
      }
    } else {
      return { roleRequired: true };
    }

    form.controls['role'].setErrors(null);
    form.controls['primaryDiscipline'].setErrors(null);
    return null;
  }

  public static validateRoleDiscipline(form: UntypedFormGroup, roles: any[]): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      return RoleDisciplineValidator.validate(form, roles);
    };
  }
}
